export default __webpack_public_path__ + "static/media/social-twitter.c9de38bf.svg";